<template>
  <div class="ap-overlay" @click.self="$emit('close')">
    <div class="ap-dialog">

      <div class="ap-header">
        <div class="ap-title"><i class="fa fa-rocket" aria-hidden="true"></i> スピード審査申し込み</div>
        <button class="ap-close" @click="$emit('close')">✕</button>
      </div>

      <div class="ap-body">
        <div class="ap-speed-wrap">
          <div class="speed-compare">
            <div class="compare-main">
              <span class="cmp-pill normal">通常審査</span>
              <div class="cmp-num normal-num">
                <span class="pre">約</span><span class="big">20</span><span class="unit">日</span>
              </div>
              <span class="cmp-sub normal-sub">で審査完了</span>

              <div class="cmp-arrow">
                <svg width="30" height="18" viewBox="0 0 30 18" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                  <line x1="0" y1="9" x2="25" y2="9" stroke="#555" stroke-width="1.5" stroke-linecap="round"/>
                  <polyline points="18,0 26,9 18,18" stroke="#555" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </div>

              <span class="cmp-pill speed">スピード審査</span>
              <div class="cmp-num blue speed-num">
                <span class="pre">最大</span><span class="big">7</span><span class="unit">営業日</span>
              </div>
              <span class="cmp-sub speed-sub">で審査完了</span>
            </div>

            <div class="premium-box">
              <div class="prem-header">
                <img src="/static/images/crown.png" alt="" aria-hidden="true" style="width:20px;height:17px;object-fit:contain;flex-shrink:0;vertical-align:middle">
                セルモンプレミアムなら
              </div>
              <div class="prem-num">
                <span class="pre">最大</span><span class="big">3</span><span class="unit">営業日</span>
              </div>
              <div class="prem-sub">で審査完了</div>
              <router-link to="/setting/plan-info" class="prem-link">詳しくはこちら <span style="font-size:16px;line-height:1">›</span></router-link>
            </div>
          </div>
        </div>

        <p class="ap-apply-note">選択した商品をスピード審査の対象として申し込みます。</p>

        <!-- ASIN section -->
        <div class="ap-asin-static">
          <div class="ap-asin-label">対象商品（ASIN）</div>
        </div>
        <div class="ap-chip-section">
          <div class="ap-asin-list-wrap">
            <div ref="asinList" :class="['ap-asin-list', showAllChips ? 'ap-asin-list--expanded' : '']" :style="!showAllChips && collapsedHeight ? { maxHeight: collapsedHeight } : {}">
              <span v-for="(item, idx) in localItems" :key="item.asin" class="ap-asin-chip">
                <span>{{ item.asin }}</span>
                <button class="ap-asin-remove" @click="removeItem(idx)" title="削除">✕</button>
              </span>
            </div>
          </div>
        </div>
      </div>

      <div v-if="showLoadMore" class="ap-loadmore-wrap">
        <button class="ap-load-more" @click="toggleChips">
          <span v-if="!showAllChips">もっと見る（残り{{ hiddenCount }}件以上）<i class="fa fa-chevron-down"></i></span>
          <span v-else>閉じる <i class="fa fa-chevron-up"></i></span>
        </button>
      </div>

      <div class="ap-static-bottom">
        <div class="ap-calc-box">
          <div class="ap-calc-section">
            <div class="ap-calc-caption">対象商品</div>
            <div class="ap-calc-price">{{ localItems.length }}</div>
          </div>
          <div class="ap-calc-operator">×</div>
          <div class="ap-calc-section">
            <div class="ap-calc-caption">1商品あたり</div>
            <div class="ap-calc-price">
              <template v-if="priceAvailable">¥{{ price.toLocaleString() }}<span class="ap-calc-tax-ex">（税抜）</span></template>
              <template v-else>¥―<span class="ap-calc-tax-ex">（税抜）</span></template>
            </div>
            <div class="ap-calc-tax-in" style="margin-top:10px">
              <template v-if="priceAvailable">¥{{ itemPriceTaxIn.toLocaleString() }}（税込）</template>
              <template v-else>¥―（税込）</template>
            </div>
          </div>
          <div class="ap-calc-operator">=</div>
          <div class="ap-calc-section ap-calc-section--total" style="margin-right:50px">
            <div class="ap-calc-price">
              <template v-if="priceAvailable"><span class="ap-total-numgroup"><span class="ap-calc-caption">合計</span><span class="ap-total-price-row"><span class="ap-total-num">¥{{ totalPriceTaxEx.toLocaleString() }}</span><span class="ap-calc-tax-ex">（税抜）</span></span><span class="ap-calc-tax-in">¥{{ totalPriceTaxIn.toLocaleString() }}（税込）</span></span></template>
              <template v-else><span class="ap-total-numgroup"><span class="ap-calc-caption">合計</span><span class="ap-total-price-row"><span class="ap-total-num">¥―</span><span class="ap-calc-tax-ex">（税抜）</span></span><span class="ap-calc-tax-in">¥―（税込）</span></span></template>
            </div>
          </div>
        </div>
      </div>

      <p class="ap-notice">※「スピード審査を申し込む」を押すと、Stripeの決済画面へ移動します。</p>

      <div class="ap-footer">
        <button class="ap-btn ap-btn-cancel" @click="$emit('close')">キャンセル</button>
        <button class="ap-btn ap-btn-primary" :disabled="loading || localItems.length === 0 || !priceAvailable" @click="$emit('purchase', localItems)">
          <span v-if="loading" class="ap-spinner"></span>
          <span v-else>スピード審査を申し込む（{{ localItems.length }}点）</span>
        </button>
      </div>

    </div>
  </div>
</template>

<script>
const TAX_RATE = 1.1

export default {
  name: 'AddByAmazonPurchaseModal',
  props: {
    items: { type: Array, default: () => [] },
    price: { type: Number, default: null },
    loading: { type: Boolean, default: false }
  },
  data () {
    return {
      localItems: [],
      showAllChips: false,
      showLoadMore: false,
      collapsedHeight: null,
      hiddenCount: 0
    }
  },
  computed: {
    priceAvailable () { return this.price !== null && this.price !== undefined },
    totalAmount () { return this.localItems.length * this.price },
    itemPriceTaxIn () { return Math.round(this.price * TAX_RATE) },
    totalPriceTaxEx () { return this.localItems.length * this.price },
    totalPriceTaxIn () { return Math.round(this.localItems.length * this.price * TAX_RATE) }
  },
  watch: {
    items (val) {
      this.localItems = [...val]
      this.showAllChips = false
      this.collapsedHeight = null
      this.$nextTick(this._checkRows)
    }
  },
  mounted () {
    this.localItems = [...this.items]
    this.$nextTick(this._checkRows)
  },
  methods: {
    _checkRows () {
      const el = this.$refs.asinList
      if (!el) return
      const chips = Array.from(el.children)
      if (!chips.length) { this.showLoadMore = false; return }

      const rows = []
      chips.forEach(chip => {
        const top = chip.offsetTop
        let row = rows.find(r => r.top === top)
        if (!row) { row = { top, bottom: 0 }; rows.push(row) }
        row.bottom = Math.max(row.bottom, chip.offsetTop + chip.offsetHeight)
      })
      rows.sort((a, b) => a.top - b.top)

      if (rows.length > 3) {
        this.showLoadMore = true
        this.collapsedHeight = rows[2].bottom + 'px'
        this.hiddenCount = chips.filter(c => c.offsetTop > rows[2].top).length
      } else {
        this.showLoadMore = false
        this.collapsedHeight = null
        this.hiddenCount = 0
      }
    },
    removeItem (idx) {
      this.localItems.splice(idx, 1)
      this.$nextTick(this._checkRows)
    },
    toggleChips () {
      const wasExpanded = this.showAllChips
      this.showAllChips = !wasExpanded
      if (wasExpanded && this.$refs.asinList) {
        this.$refs.asinList.scrollTop = 0
      }
    }
  }
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Noto+Sans+JP:wght@400;500;700;900&display=swap');
.ap-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1050;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  font-family: 'ヒラギノ角ゴ ProN W3', 'Hiragino Kaku Gothic ProN', 'メイリオ', 'Meiryo', 'ＭＳ Ｐゴシック', 'MS PGothic', sans-serif;
}
@keyframes ap-in {
  from { transform: translateY(-12px); opacity: 0; }
  to   { transform: translateY(0);     opacity: 1; }
}
.ap-spinner {
  display: inline-block;
  width: 16px; height: 16px;
  border: 2px solid rgba(255,255,255,0.4);
  border-top-color: #fff;
  border-radius: 50%;
  animation: ap-spin 0.7s linear infinite;
  vertical-align: middle;
}
@keyframes ap-spin { to { transform: rotate(360deg); } }

.ap-dialog {
  font-family: 'Noto Sans JP', 'Hiragino Sans', 'Yu Gothic UI', system-ui, sans-serif;
  background: #fff;
  border-radius: 6px;
  width: 583px;
  max-width: 96vw;
  max-height: 85vh;
  display: flex;
  flex-direction: column;
  box-shadow: 0 20px 60px rgba(0,0,0,.35);
  overflow: hidden;
  animation: ap-in 0.18s ease;
}

.ap-header {
  background: #1e88c7;
  color: #fff;
  padding: 14px 18px;
  display: flex;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
}
.ap-title { font-size: 15px; font-weight: 700; flex: 1; }
.ap-close {
  background: transparent;
  border: none;
  color: #fff;
  font-size: 18px;
  cursor: pointer;
  opacity: 0.9;
  line-height: 1;
  padding: 4px;
}
.ap-close:hover { opacity: 1; }

.ap-body {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
}
.ap-asin-static {
  flex-shrink: 0;
  padding: 0 20px 0;
}
.ap-asin-label { font-size: 12px; color: #586170; font-weight: 700; margin-bottom: -7px; }
.ap-chip-section {
  flex-shrink: 0;
  padding: 8px 20px 0;
  min-width: 0;
}
.ap-asin-list-wrap { position: relative; }
.ap-asin-list {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 8px;
  overflow: hidden;
  padding: 8px 8px 0 0;
}
.ap-asin-list--expanded {
  max-height: none;
  overflow: visible;
}
.ap-asin-chip {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: #eaf5fb;
  border: 1px solid #d8e8f0;
  color: #1a75ab;
  font-size: 12px;
  font-weight: 600;
  padding: 6px 12px;
  border-radius: 4px;
  font-family: monospace;
}
.ap-asin-remove {
  position: absolute;
  top: -6px;
  right: -6px;
  border: 1px solid #fff;
  background: #b9c4cd;
  color: #fff;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  font-size: 9px;
  line-height: 1;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  box-shadow: 0 1px 3px rgba(0,0,0,.2);
}
.ap-asin-remove:hover { background: #e74c3c; }
.ap-empty-state {
  padding: 16px 0 8px;
  color: #8a97a3;
  font-size: 13px;
  text-align: center;
}

.ap-loadmore-wrap {
  flex-shrink: 0;
  padding: 0 20px 8px;
}
.ap-load-more {
  display: block;
  width: 100%;
  margin-top: 8px;
  background: none;
  border: 1px dashed #b8ddf0;
  border-radius: 3px;
  color: #008cc6;
  font-size: 12px;
  padding: 5px 8px;
  cursor: pointer;
  text-align: center;
  transition: background 0.12s;
}
.ap-load-more:hover { background: #f0f9ff; }

.ap-speed-wrap {
  padding: 16px 20px 0;
  display: flex;
  justify-content: center;
}
.speed-compare {
  display: flex;
  gap: 10px;
  align-items: stretch;
  max-width: 560px;
  width: 100%;
}
.compare-main {
  flex: 1;
  background: #F0F6FA;
  border-radius: 8px;
  padding: 15px 10px;
  display: grid;
  grid-template-columns: 1fr 20px 1fr;
  grid-template-rows: auto auto auto;
  align-items: center;
  row-gap: 5px;
}
.cmp-pill {
  font-size: 12px;
  font-weight: 700;
  padding: 3px 20px;
  border-radius: 20px;
  white-space: nowrap;
  line-height: 1.5;
  justify-self: center;
}
.cmp-pill.normal {
  grid-area: 1 / 1;
  background: #D5E0EB;
  color: #636c78;
  border: 1.5px solid #D4E4F0;
}
.cmp-pill.speed {
  grid-area: 1 / 3;
  background: #1C7ED6;
  color: #fff;
}
.cmp-num {
  display: flex;
  align-items: baseline;
  gap: 1px;
  line-height: 1;
  justify-self: center;
}
.cmp-num.normal-num { grid-area: 2 / 1; color: #636c78; }
.cmp-num.speed-num  { grid-area: 2 / 3; }
.cmp-num .pre  { font-size: 19px; font-weight: 700; }
.cmp-num .big  { font-size: 48px; font-weight: 900; font-variant-numeric: tabular-nums; line-height: .95; }
.cmp-num .unit { font-size: 22px; font-weight: 700; }
.cmp-num.blue .big  { color: #1C7ED6; }
.cmp-num.blue .pre  { color: #1C7ED6; font-weight: 700; font-size: 22px; }
.cmp-num.blue .unit { color: #1C7ED6; font-size: 28px; }
.cmp-sub {
  font-size: 13px;
  color: #555;
  justify-self: center;
  font-weight: 500;
}
.cmp-sub.normal-sub { grid-area: 3 / 1; }
.cmp-sub.speed-sub  { grid-area: 3 / 3; color: #1C7ED6; font-weight: 700; }
.cmp-arrow {
  grid-area: 2 / 2;
  font-size: 20px;
  color: #1A1A1A;
  justify-self: center;
  align-self: center;
  margin: 16px 19px 0 0;
}
.premium-box {
  width: 170px;
  flex-shrink: 0;
  background: #fcf9ea;
  border: 1.5px solid #f6da8b;
  border-radius: 8px;
  padding: 11px 12px 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 3px;
}
.prem-header {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 12px;
  font-weight: 700;
  color: #A07A00;
  white-space: nowrap;
}
.prem-num {
  display: flex;
  align-items: baseline;
  gap: 1px;
  line-height: 1;
  margin-top: 2px;
}
.prem-num .pre  { font-size: 17px; font-weight: 700; color: #E8A000; margin-right: 5px; }
.prem-num .big  { font-size: 36px; font-weight: 900; color: #E8A000; font-variant-numeric: tabular-nums; line-height: .95; margin-right: 5px; }
.prem-num .unit { font-size: 21px; font-weight: 700; color: #E8A000; }
.prem-sub { font-size: 12px; color: #A07A00; font-weight: 500; }
.prem-link {
  display: inline-block;
  margin-top: 5px;
  font-size: 13px;
  font-weight: 700;
  text-decoration: none;
  background-color: #fdf1cb;
  border-radius: 4px;
  padding: 4px 10px;
  width: 100%;
  text-align: center;
  color: #A07A00;
  transition: background .18s, box-shadow .18s, transform .18s, color .18s;
}
.prem-link:hover {
  background: #fbe89e;
  color: #7a5c00;
  box-shadow: 0 2px 8px rgba(232,160,0,.28);
  transform: translateY(-1px);
}
.ap-apply-note {
  font-size: 13px;
  color: #7b818d;
  line-height: 1.65;
  text-align: left;
  padding: 15px 20px;
  margin: 0;
}
.ap-notice {
  font-size: 11.5px;
  color: var(--text-muted, #888);
  line-height: 1.7;
  padding: 0 20px 8px;
  margin: 0;
}

.ap-static-bottom {
  flex-shrink: 0;
  padding: 16px 20px 8px;
}

.ap-calc-box {
  border: none;
  border-radius: 8px;
  background: #f4fafd;
  padding: 15px 20px;
  display: flex;
  justify-content: space-around;
  gap: 16px;
  align-items: flex-start;
}
.ap-calc-section { text-align: left; }
.ap-calc-section:first-child { text-align: center; }
.ap-total-numgroup {
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  vertical-align: bottom;
  margin-top: 5px;
}
.ap-total-price-row { display: inline-flex; align-items: baseline; position: relative; }
.ap-total-price-row .ap-calc-tax-ex { position: absolute; left: 100%; bottom: 0; white-space: nowrap; }
.ap-calc-operator { font-size: 26px; font-weight: 600; color: #90a4b0; margin-top: 26px; line-height: 38px; }
.ap-calc-caption { font-size: 13px; font-weight: 500; color: #8a97a3; margin-bottom: 10px; white-space: nowrap; }
.ap-calc-price { font-size: 30px; font-weight: 800; color: #1e88c7; line-height: 1; }.ap-calc-tax-ex { font-size: 12px; font-weight: 400; color: #8a97a3; }
.ap-calc-tax-in { font-size: 12px; font-weight: 500; color: #8a97a3; margin-top: 12px; }

.ap-footer {
  display: flex;
  justify-content: flex-end;
  align-items: stretch;
  gap: 10px;
  padding: 14px 20px 18px;
  flex-shrink: 0;
}
.ap-btn {
  border: none;
  border-radius: 5px;
  font-size: 13px;
  font-weight: 700;
  padding: 10px 20px;
  cursor: pointer;
  font-family: inherit;
  white-space: nowrap;
}
.ap-btn-cancel {
  background: #fff;
  border: 1px solid #c7d2d9;
  color: #5a6570;
}
.ap-btn-cancel:hover { background: #f5f7f8; }
.ap-btn-primary {
  background: #1e88c7;
  color: #fff;
}
.ap-btn-primary:hover:not(:disabled) { background: #1a75ab; }
.ap-btn-primary:disabled { background: #b9c4cd; cursor: not-allowed; }
</style>



// WEBPACK FOOTER //
// src/view/productsNew/AddByAmazonPurchaseModal.vue